import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_BIZ_USER, IS_PAID_USER, IS_PHONE_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { promotionEndDate } from 'reactApp/appHelpers/featuresHelpers';
import { features } from 'reactApp/mail-features';

const segment = !IS_BIZ_USER && !IS_PAID_USER;

export const blackFriday2025: boolean = segment && promotionEndDate && getFeature('black-friday-2025');

export const blackFriday2025Tariff: string = blackFriday2025 ? getFeature('black-friday-2025-tariff') || 'W1TB_1y_bf_2025_discount' : '';

export const blackFriday2025TariffFamily = getFeature('black-friday-2025-tariff-family');

export const blackFriday2025TariffSpaceEveryone = getFeature('black-friday-2025-tariff-space-everyone');

const blackFriday2025Modal: false | 'a' | 'b' = blackFriday2025 && !IS_PHONE_BROWSER && getFeature('bf2025-modal-ab');

export const blackFriday2025ModalA = blackFriday2025Modal === 'a';
export const blackFriday2025ModalB = blackFriday2025Modal === 'b';

/** id промо - для включения нужно будет включать фичу app.enableFeature('3promo-enable-bf2025-modal') */
export const PROMO_ID = 'bf2025-modal';
/** Ключ для локалстораджа от баннера */
export const storageKeyForBanner = `3promo:${PROMO_ID}`;

/** Временной промежуток между показами одной и той же промки, в секундах */
export const showInterval: number = features.getAsInt(`${PROMO_ID}-show-interval`, 604800);
/** Максимальное количество закрытий промки (на крестик в баннере / на primary кнопку) */
export const closeLimit: number = features.getAsInt(`${PROMO_ID}-close-limit`, 3);
/** Максимальное количество показов, в которых не взаимодействуют с промкой */
export const showLimit: number = features.getAsInt(`${PROMO_ID}-show-limit`, 3);

export const bf2025ModalCTAUrl: string = features.getAsString('bf2025-modal-cta-url', 'https://cloud.mail.ru/promo/quota');
